import { Trans } from 'react-i18next';

import { CosmosKitWallets } from './components/connections/CosmosKitWallets/CosmosKitWallets';
import { EmailConnection } from './components/connections/EmailConnection';
import { LoginFooter } from './components/connections/LoginFooter';
import { Or } from './components/connections/Or';
import { SocialConnections } from './components/connections/SocialConnections';
import { VerifyMessage } from './components/VerifyMessage';
import { Spacer } from '../misc/Spacer';

export const LoginForm = ({compact = false}: {compact?: boolean}) => {
  return (
    <>
      <div className="mt-4 flex w-full flex-col items-center gap-5 desktop:max-w-[375px] mobile:px-5">
        {!compact && (
          <div className="flex w-full flex-col items-center gap-2.5">
            <h1 className="color-black text-[40px] font-semibold leading-normal mobile:text-[32px]">
              <Trans i18nKey="connect.heading" />
            </h1>

            <VerifyMessage />
          </div>
        )}

        <EmailConnection />

        <div className="flex w-full flex-col items-center">
          <Spacer size={5} />

          <Or />

          <Spacer size={10} />

          <div className="flex w-full">
            <SocialConnections />
          </div>
        </div>

        <CosmosKitWallets />
      </div>

      {!compact && (
        <>
          <div className="max-h-[90px] flex-1" />
          <LoginFooter />
        </>
      )}
    </>
  );
};
